/**
 * Generate SHA-256 hash of a file using the Web Crypto API.
 * No external dependencies; uses browser crypto.subtle.digest.
 */

function bufferToHex(hashBuffer: ArrayBuffer): string {
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export async function generateFileHash(file: File): Promise<string> {
  const buffer = await file.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return bufferToHex(hashBuffer)
}

/** Hash arbitrary bytes (e.g. from fetch response). Used to validate already-uploaded resume. */
export async function generateHashFromArrayBuffer(buffer: ArrayBuffer): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return bufferToHex(hashBuffer)
}
